import apiClient from './client'
import type { Aviso, AvisoCreateContext, CreateAvisoRequest, UpdateAvisoRequest, PaginatedResponse } from '@/types/aviso'

export const avisosApi = {
    getAll: (params?: { search?: string; idTipoAviso?: string; idCliente?: string; finalizado?: string; page?: number; pageSize?: number }) =>
        apiClient.get<PaginatedResponse<Aviso>>('/avisos', { params }).then((r) => r.data),

    getById: (id: number) =>
        apiClient.get<Aviso>(`/avisos/${id}`).then((r) => r.data),

    getCreateContext: () =>
        apiClient.get<AvisoCreateContext>('/avisos/context').then((r) => r.data),

    create: (data: CreateAvisoRequest) =>
        apiClient.post<Aviso>('/avisos', data).then((r) => r.data),

    update: (id: number, data: UpdateAvisoRequest) =>
        apiClient.put<Aviso>(`/avisos/${id}`, data).then((r) => r.data),

    close: (id: number) =>
        apiClient.patch<Aviso>(`/avisos/${id}/cerrar`).then((r) => r.data),

    reopen: (id: number) =>
        apiClient.patch<Aviso>(`/avisos/${id}/reabrir`).then((r) => r.data),

    delete: (id: number) =>
        apiClient.delete(`/avisos/${id}`),
}
